import translation from "./translation";
import frontpage from "./frontpage";
import application from "./application";

const en = {
	translation,
	frontpage,
	application
} as const;

export default en;
